import React from 'react';
import { cn } from '../../lib/utils';

const buttonVariants = {
  base: 'inline-flex items-center justify-center whitespace-nowrap rounded-full text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
  variants: {
    default: 'bg-primary text-white hover:bg-primary-hover',
    destructive: 'bg-danger-600 text-white hover:bg-danger-700',
    outline: 'border border-border bg-card hover:bg-hover text-foreground',
    secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary-hover',
    ghost: 'hover:bg-hover text-foreground',
    link: 'text-primary underline-offset-4 hover:underline',
  },
  sizes: {
    default: 'h-10 px-4 py-2',
    sm: 'h-9 rounded-lg px-3 text-xs',
    lg: 'h-11 rounded-lg px-8',
    icon: 'h-10 w-10',
  },
};

const Button = React.forwardRef(({
  className,
  variant = 'default',
  size = 'default',
  children,
  ...props
}, ref) => {
  return (
    <button
      className={cn(
        buttonVariants.base,
        buttonVariants.variants[variant],
        buttonVariants.sizes[size],
        className
      )}
      ref={ref}
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = 'Button';

export { Button, buttonVariants };
